import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@fontsource-variable/onest'

import App from '@/App'
import { AuthProvider } from '@/auth/AuthProvider'
import ErrorBoundary from '@/components/ErrorBoundary'
import '@/app/globals.css'

document.title = import.meta.env.DEV ? 'DEV: ORI — Админ' : 'ORI — Админ'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
)
